import $ from 'jquery';

const Video = {
    bindEvents: () => {
        const videos = document.getElementsByClassName('sib-media-gallery__video--play');
        if (videos.length) {
            Video.getMediaGalleryVideos(videos);
        } else {
            const vimeos = document.querySelectorAll('[data-video="vimeo"]');
            if (vimeos.length) {
                Video.getVimeoThumbnail(vimeos);
            }
        }
        // this will check if the youtube video has a HD thumbnail
        const youtubeThumbs = document.getElementsByClassName('sib-video__thumb');
        if (youtubeThumbs.length) Video.checkHDThumb(youtubeThumbs);
    },

    checkHDThumb: (thumbs) => {
        for (let i = 0; i < thumbs.length; i++) {
            let thumb = thumbs[i],
                id = thumb.hasAttribute('data-ref') ? thumb.getAttribute('data-ref') : '0',
                type = thumb.hasAttribute('data-video') ? thumb.getAttribute('data-video') : 'vimeo',
                url = thumb.hasAttribute('style') ? thumb.getAttribute('style') : '';
            if (type === 'youtube' && url !== '') {
                // get Image URL
                let stringUrl = url.match(/\'(.*)\'/g);
                try {
                    let imageUrl = stringUrl[0].slice(1, -1);
                    let newUrl = imageUrl.replace('hqdefault.jpg', 'maxresdefault.jpg');

                    // check if the image exists
                    $.get('/thumb.php?id=' + id, function() {
                        // console.log('check image!');
                    })
                        .done(function(resp) {
                            if (resp === 'true') thumb.setAttribute('style', `background-image: url('${newUrl}')`);
                            // console.log('Update thumb');
                        })
                        .fail(function() {
                            // console.log('unable to find HD thumb!');
                        });
                } catch(e) {
                    console.log(e);
                }
            }
        }
    },

    getMediaGalleryVideos: (videos) => {

        for (let i = 0; i < videos.length; i++) {

            let video = videos[i];
            if (video.getAttribute('data-video') === 'youtube') {
                $.ajax({
                    url: `https://www.googleapis.com/youtube/v3/videos?id=${videos[i].getAttribute('data-ref')}&key=AIzaSyA_NO_vKq3OexcPYJwYFSk0aYiPUBAFcII&part=contentDetails&snippet`,
                    type: 'get',
                    success: function (result) {
                        // console.log(result);
                        let durationHolder = video.previousElementSibling;
                        durationHolder.innerHTML = Video.convertTime(result['items'][0]['contentDetails']['duration']);
                        let parent = video.parentElement.parentElement.parentElement;
                        parent.style.backgroundImage = `url("https://img.youtube.com/vi/${video.getAttribute('data-ref')}/hqdefault.jpg")`;
                        parent.style.backgroundPosition =  `50% 50%`;
                    }
                });
            } else {

                $.ajax({
                    url: `https://vimeo.com/api/v2/video/${videos[i].getAttribute('data-ref')}.json`,
                    type: 'get',
                    success: function (result) {
                        console.log(result);
                        let durationHolder = video.previousElementSibling;
                        let parent = video.parentElement.parentElement.parentElement;
                        durationHolder.innerHTML = Video.toHHMMSS(result[0].duration);
                        parent.style.backgroundImage = `url(${result[0].thumbnail_large})`;
                        parent.style.backgroundPosition =  `50% 50%`;
                    }
                });


            }

        }
    },

    toHHMMSS :(duration) => {
        var sec_num = parseInt(duration, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes =  minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ':' + seconds;
    },
    getVimeoThumbnail: (vimeos) => {

        for (let i = 0; i < vimeos.length; i++) {

            const VideoId = vimeos[i].getAttribute('data-ref');
            $.ajax({
                url: `https://vimeo.com/api/v2/video/${VideoId}.json`,
                type: 'get',
                success: function (result) {
                    const vimeo_thumbnail = result[0].thumbnail_large.replace('_640.jpg', '_1600.jpg');
                    vimeos[i].style.backgroundImage = `url(${vimeo_thumbnail})`;

                }
            });
        }
    },
    convertTime: (duration) => {
        let match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

        match = match.slice(1).map(function (x) {
            if (x != null) {
                return x.replace(/\D/, '');
            }
        });

        let hours = (parseInt(match[0]) || 0);
        let minutes = (parseInt(match[1]) || 0);
        let seconds = (parseInt(match[2]) || 0);

        return `${minutes}:${seconds}`;
    }
};

module.exports = Video;



// WEBPACK FOOTER //
// ./src/js/partials/video.js